<template>
  <div class="check">
    <selfcheck-calling-modal invert :visible="isCalling">
      <so-quit-button-container class="quit-button" />
    </selfcheck-calling-modal>

    <transition-group name="fade">
      <div v-if="animationPlaying" :key="0" class="animation-content">
        <div class="animation-image">
          <img v-if="cashRegisterType === 0" src="@/assets/images/annai_regi_sp_self.gif" alt="" />
          <img v-if="cashRegisterType === 1" src="@/assets/images/annai_regi_sp.gif" alt="" />
        </div>
        <div class="animation-text">
          <span>{{ $t('selfcheck.checkConfirmed') }}</span>
          <br />
          <span>{{ $t('selfcheck.takeNumberPlateToTheCounter') }}</span>
        </div>
        <so-quit-button-container class="quit-button" />
      </div>
    </transition-group>
    <div v-if="!animationPlaying" class="wrapper">
      <selfcheck-progress :active-index="2" />

      <div class="info">
        <img src="@/assets/images/check.svg" alt="" class="image-check" />
        <div class="info-text">{{ $t('selfcheck.checkConfirmed') }}</div>
      </div>

      <check-details
        :title="$t('common.check')"
        :check-infos="checkInfos"
        :tax-amount="taxAmount"
      />

      <div class="image-ticket"><img src="@/assets/images/information-ticket.svg" alt="" /></div>
      <div class="text">{{ $t('selfcheck.takeNumberPlateToTheCounter') }}</div>
      <ul class="selfcheck-complete-nav">
        <li>
          <so-button variant="gray" rounded @click="handleCall">{{
            $t('common.staffCalling')
          }}</so-button>
        </li>
        <li>
          <so-quit-button-container class="quit-button" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import SoButton from '@/components/common/SoButton'
import SoQuitButtonContainer from '@/components/common/SoQuitButton.container'
import SelfcheckProgress from '@/components/selfcheck/SelfcheckProgress'
import CheckDetails from '@/components/selfcheck/CheckDetails'
import SelfcheckCallingModal from '@/components/modal/SelfcheckCallingModal'

export default {
  name: 'Check',
  components: {
    SoButton,
    SoQuitButtonContainer,
    SelfcheckProgress,
    CheckDetails,
    SelfcheckCallingModal,
  },
  data() {
    return {
      isCalling: false,
      animationStartTime: 4000,
      animationEndTime: 21000, // gitアニメーション(6000) * 3 + animationStartTime - fadeout(500) - 微調整(500)
      animationStartHandle: null,
      animationEndHandle: null,
      animationPlaying: false,
    }
  },
  computed: {
    ...mapGetters({
      checkInfos: 'selfcheck/getCheckInfos',
      taxAmount: 'selfcheck/getTaxAmount',
      cashRegisterType: 'seat/getCashRegisterType',
      error: 'selfcheck/getError',
    }),
  },
  mounted() {
    if (this.taxAmount === 0) this.fetchSeatAmount()
    this.animationStartHandle = setTimeout(this.startAnimation, this.animationStartTime)
    this.animationStopHandle = setTimeout(this.stopAnimation, this.animationEndTime)
  },
  destroyed() {
    clearTimeout(this.animationIntervalHandle)
    clearTimeout(this.animationStartHandle)
  },
  beforeRouteLeave(_to_, _from_, next) {
    next(false)
  },
  methods: {
    ...mapActions({
      deauth: 'auth/deauth',
      callStaffSelfcheck: 'selfcheck/callStaffSelfcheck',
      setShowingSelfcheckErrorModal: 'modal/setShowingSelfcheckErrorModal',
      setShowingSimpleErrorModal: 'modal/setShowingSimpleErrorModal',
      fetchSeatAmount: 'selfcheck/fetchSeatAmount',
    }),
    async handleCall() {
      await this.callStaffSelfcheck()

      if (!this.error) {
        this.isCalling = true
      } else {
        if (this.error.response) {
          this.setShowingSelfcheckErrorModal(true)
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
    startAnimation() {
      this.animationPlaying = true
    },
    stopAnimation() {
      this.animationPlaying = false
    },
  },
  head: {
    title() {
      return {
        inner: this.$t('common.check'),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.check {
  min-height: 100%;
}
.animation-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  padding-bottom: 15px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.animation-text {
  padding: 30px 0;
  font-size: 20px;
  white-space: pre-wrap;
}
.wrapper {
  padding: 15px 15px 0;

  @media screen and (min-width: 500px) {
    padding: 15px 15px 0;
  }
}
.content {
  width: 100%;
  padding: 10px 30px;
  background: #f2f2f2;
  border-radius: 20px;
  font-size: 26px;
  color: #222;
}
.info {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}
.info-text {
  font-size: 20px;
}
.image-check {
  width: 25px;
  margin-right: 5px;
}
.image-ticket {
  width: 80px;
  margin: 30px auto;
}
.text {
  margin: 20px 0 8px;
  font-size: 20px;
  white-space: pre-wrap;
}
.modal-button {
  max-width: 240px;
}
.selfcheck-complete-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 12px 12px 0;

  @media screen and (min-width: 500px) {
    flex-direction: row;
    justify-content: space-between;
  }
  li {
    width: 100%;
    max-width: 300px;
    padding-bottom: 12px;
    list-style: none;

    & + li {
      @media screen and (min-width: 500px) {
        margin-left: 12px;
      }
    }
  }
  .button {
    height: 48px;
  }
}
.quit-button {
  height: 48px;
  max-width: 300px;
  margin: 0 auto;
}
</style>
